import React, { useEffect, useState } from 'react';
import { Box, Content, Message } from '../../lib/carbon-ui';
import { IMessageOrToastOptions, MessageorToastOptionsDefaultState } from './MessageOrToastOptions';
import ReactHtmlParser from 'react-html-parser';

// Re-export to save importing from multiple files when using DefaultToast
export type { IMessageOrToastOptions };
export { MessageorToastOptionsDefaultState };

interface DefaultMessageProps {
  messageOptions: IMessageOrToastOptions;
}

const DefaultMessage = (props: DefaultMessageProps) => {
  const { messageOptions } = props;
  const [ message, setMessage ] = useState<IMessageOrToastOptions>(MessageorToastOptionsDefaultState);

  useEffect(() => {
    setMessage(messageOptions);
  }, [messageOptions]);

  return (
    <Box mb={message.isOpen ? 3 : 0}>
      <Message variant={message.variant} open={message.isOpen} showCloseIcon={false} >
        <Content title={message.title} variant='primary'>
          {ReactHtmlParser(message.message)}
        </Content>
      </Message>
    </Box>
  );
};

export default DefaultMessage;
